export default "__VITE_ASSET__BIT3kb2c__"